import React, { useState } from 'react';
import { Box } from '@mui/material';
import { GenericAutoCompleteUserProfile } from './GenericAutoCompleteUserProfile';
import { TapGlobalMessages } from 'TAP/global';
import { useScreen } from 'common/hooks/useScreen';

const MyTeamProfileFilters = ({
  wwidOptions,
  partnerOptions,
  workerTypeOptions,
  onWWIDChange,
  onPartnerCompanyChange,
  onWorkerTypeChange,
  workerTypeValues,
  wwidValues,
  partnerCompanyValues,
}) => {
  const USER = 'User';
  const PARTNER_COMPANY = 'Partner_Company';
  const WORKER_TYPE = 'Worker_Type';
  const screen = useScreen();

  const [isWWIDSwitchOn, setIsWWIDSwitchOn] = useState(true);
  const [isParnterCompanySwitchOn, setIsPartnerCompanySwitchOn] = useState(true);
  const [isWorkerTypeSwitchOn, setIsWorkerTypeSwitchOn] = useState(true);
  const [wwidChecked, setWWIDChecked] = useState(false);
  const [partnerCompanyChecked, setPartnerCompanyChecked] = useState(false);
  const [workerTypeChecked, setWorkerTypeChecked] = useState(false);

  const switchChange = (_e, type) => {
    if (type === USER) {
      setIsWWIDSwitchOn(!isWWIDSwitchOn);
      setWWIDChecked(!!wwidChecked);
    } else if (type === PARTNER_COMPANY) {
      setIsPartnerCompanySwitchOn(!isParnterCompanySwitchOn);
      setPartnerCompanyChecked(!partnerCompanyChecked);
    } else if (type === WORKER_TYPE) {
      setIsWorkerTypeSwitchOn(!isWorkerTypeSwitchOn);
      setWorkerTypeChecked(!workerTypeChecked);
    }
  };

  const getEqualityCheck = (option, value, type) => {
    if (type === USER) {
      return value && option.user_id === value.user_id;
    } else if (type === PARTNER_COMPANY) {
      return value && option === value;
    } else if (type === WORKER_TYPE) {
      return value && option === value;
    } else {
      return false;
    }
  };

  const getLabeledOptions = (option, type) => {
    if (type === USER) {
      return `(${option.user_id}) ${option.full_name}`;
    } else if (type === PARTNER_COMPANY) {
      return option;
    } else if (type === WORKER_TYPE) {
      return option;
    }
  };

  return (
    <Box sx={{ display: 'flex', width: '80%', justifyContent: 'space-between', flexDirection: screen.isMobile ? 'column' : ''}} data-testid ='MyTeamProfileFilters'>
      <GenericAutoCompleteUserProfile
        options={wwidOptions}
        values={wwidValues}
        switchChangeHandler={switchChange}
        getLabeledOptions={getLabeledOptions}
        getEqualityCheck={getEqualityCheck}
        checked={wwidChecked}
        type={USER}
        placeholder={
          wwidValues?.length
            ? `${wwidValues.length} ${TapGlobalMessages.userGroupProfile.myTeamProfile.selected}`
            : `${TapGlobalMessages.userGroupProfile.myTeamProfile.search}`
        }
        heading={TapGlobalMessages.userGroupProfile.myTeamProfile.wwid}
        switchIndicator={isWWIDSwitchOn}
        isSwitchToShow={false}
        handleAutoCompleteChange={onWWIDChange}
      />
      <GenericAutoCompleteUserProfile
        options={partnerOptions}
        values={partnerCompanyValues}
        switchChangeHandler={switchChange}
        getLabeledOptions={getLabeledOptions}
        getEqualityCheck={getEqualityCheck}
        checked={partnerCompanyChecked}
        type={PARTNER_COMPANY}
        placeholder={
          partnerCompanyValues?.length
            ? `${partnerCompanyValues.length} ${TapGlobalMessages.userGroupProfile.myTeamProfile.selected}`
            : `${TapGlobalMessages.userGroupProfile.myTeamProfile.search}`
        }
        heading={TapGlobalMessages.userGroupProfile.myTeamProfile.partnerCompany}
        switchIndicator={isParnterCompanySwitchOn}
        isSwitchToShow={false}
        handleAutoCompleteChange={onPartnerCompanyChange}
      />
      <GenericAutoCompleteUserProfile
        options={workerTypeOptions}
        values={workerTypeValues}
        switchChangeHandler={switchChange}
        getLabeledOptions={getLabeledOptions}
        getEqualityCheck={getEqualityCheck}
        checked={workerTypeChecked}
        type={WORKER_TYPE}
        placeholder={
          workerTypeValues?.length
            ? `${workerTypeValues.length} ${TapGlobalMessages.userGroupProfile.myTeamProfile.selected}`
            : `${TapGlobalMessages.userGroupProfile.myTeamProfile.search}`
        }
        heading={TapGlobalMessages.userGroupProfile.myTeamProfile.workerType}
        switchIndicator={isWorkerTypeSwitchOn}
        isSwitchToShow={false}
        handleAutoCompleteChange={onWorkerTypeChange}
      />
    </Box>
  );
};

export default MyTeamProfileFilters;
